import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { Scatter } from '@ant-design/charts';

import './Analyze.less';
import { Card, Col, Row, Tabs } from 'antd';
import { useStores } from '@app/hooks/stores';
import { Color } from '@app/themes/colors';
import Spinner from '@app/common/Spinner';

const { TabPane } = Tabs;

declare type AnalyzeProps = {};

const reportIntervalMs = 10 * 60 * 1000;

const Analyze: React.FC<AnalyzeProps> = () => {
  const { analyzeStore, dashboardStore } = useStores();
  const { getAllBuildings, setSelectBuildingId } = dashboardStore;

  useEffect(() => {
    getAllBuildings();
    const reportPullInterval = setInterval(getAllBuildings, reportIntervalMs);
    return () => {
      clearInterval(reportPullInterval);
    };
  }, []);

  const leakMapperData = analyzeStore.getLeakMapperData();

  const leakChart = analyzeStore.getChartConfig({
    xField: 'powerAverage',
    yField: 'estimateKWh',
    colorField: 'short',
    meta: {
      powerAverage: {
        alias: 'Average Power'
      },
      estimateKWh: {
        alias: 'Annual Consumption kWh'
      },
      room: {
        alias: 'Room'
      },
      short: {
        alias: 'Room'
      }
    },
    color: [Color.purple, Color.green, Color.blue, Color.red]
  });

  // @ts-ignore
  leakChart.xAxis.title = { text: 'average power', style: { opacity: 0.7 } };
  // @ts-ignore
  leakChart.yAxis.title = { text: 'projected consumption', offset: 80, style: { opacity: 0.7 } };

  const map1: any = {
    ...leakChart
  };
  map1.data = leakMapperData.data1;

  const map2: any = {
    ...leakChart
  };
  map2.data = leakMapperData.data2;

  const map3: any = {
    ...leakChart
  };
  map3.data = leakMapperData.data3;

  const map4: any = {
    ...leakChart
  };
  map4.data = leakMapperData.data4;

  const map5: any = {
    ...leakChart
  };
  map5.data = leakMapperData.data5;

  const { loading, buildings } = dashboardStore;

  const onTabChange = key => {
    setSelectBuildingId(key);
  };

  if (loading) return <Spinner />;

  return (
    <Tabs className="dashboard" onChange={onTabChange}>
      {buildings &&
        buildings.map(building => (
          <TabPane tab={building.name} key={building.id}>
            <Row gutter={24}>
              <Col lg={24} md={24}>
                <Card title="Sunday, June 06, 2021">
                  <Scatter {...map5} />
                </Card>
              </Col>
              <Col lg={24} md={24}>
                <Card title="Sunday, May 30, 2021">
                  <Scatter {...map4} />
                </Card>
              </Col>
              <Col lg={24} md={24}>
                <Card title="Sunday, May 23, 2021">
                  <Scatter {...map3} />
                </Card>
              </Col>
              <Col lg={24} md={24}>
                <Card title="Sunday, May 16, 2021">
                  <Scatter {...map2} />
                </Card>
              </Col>
              <Col lg={24} md={24}>
                <Card title="Sunday, May 09, 2021">
                  <Scatter {...map1} />
                </Card>
              </Col>
            </Row>
          </TabPane>
        ))}
    </Tabs>
  );
};

export default observer(Analyze);
